import { render, staticRenderFns } from "./CollapsableContent.vue?vue&type=template&id=2bc50a97&"
import script from "./CollapsableContent.vue?vue&type=script&lang=js&"
export * from "./CollapsableContent.vue?vue&type=script&lang=js&"
import style0 from "./CollapsableContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports